<template>
  <!-- <div class="home">
    <v-data-table
      :headers="headers"
      :items="desserts"
      :items-per-page="5"
      class="order-data-table"
    ></v-data-table>
  </div>-->
  <div>
    <Header/>
    <v-row>
      <v-col cols="8" md="8" class="d-flex"></v-col>
      <v-col cols="2" md="2" class="d-flex">
        <v-chip
          class="ma-2"
          color="primary"
          label
        >
          <v-icon left>home_work</v-icon>
          RTS Queue: {{rtsQueue}}
        </v-chip>
      </v-col>
      <v-col cols="2" md="2" class="d-flex">
        <addOrder @newOrderAdded="changeTab ('Active Order')"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2" md="2" class="d-flex">
        <v-card max-width="300" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <!-- <div class="overline mb-4">OVERLINE</div> -->
              <v-list-item-title class="headline mb-1">Total Open Orders</v-list-item-title>
              <v-list-item-avatar tile size="80" style="font-size:4rem;">{{rtsQueue}}</v-list-item-avatar>
              <!-- <v-list-item-subtitle>Greyhound divisely hello coldly fonwderfully</v-list-item-subtitle> -->
            </v-list-item-content>

          </v-list-item>

          <!-- <v-card-actions>
            <v-btn text>Button</v-btn>
            <v-btn text>Button</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-col>
      <v-col cols="5" md="5" class="d-flex align-center">
        <v-simple-table :fixed-header="true" :height="height">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 35rem !important;color: #2c6d80;">Customers</th>
                <th class="text-left" style="color: #2c6d80;">Total Orders</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in orderCountByCustomer" :key="item.name">
                <td>{{ item.client__name }}</td>
                <td>{{ item.count }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="5" md="5" class="d-flex align-center">
        <v-simple-table :fixed-header="true" :height="height">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" style="width: 35rem !important;color: #2c6d80;">Status</th>
                <th class="text-left" style="color: #2c6d80;">Orders</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in statusCount" :key="item.name">
                <td>{{ item.status__name }}</td>
                <td>{{ item.count }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-btn text flat v-bind:class="[activeTab=='Active Order'? 'primary': '', 'rtsFilter']" @click="changeTab('Active Order')">Active Orders</v-btn>
      <v-btn  v-bind:class="[activeTab==filter.name? 'primary': '', 'rtsFilter']" @click="changeTab(filter.name)" text v-for="filter in filters"
        :key="filter.name" flat>{{filter.name}}</v-btn>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" class="d-flex align-center">
        <dataTable :exportURL="exportURL" @pageChanged="paginateOrder" :dataTableData="dataTableData" :headers="headers" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
// @ is an alias to /src
import JwtService from '@/common/jwt.service'
import Header from '@/components/header.vue'
import API_URL from '@/common/config'
import addOrder from '@/components/addOrder.vue'
import dataTable from '@/components/dataTable.vue'
import { GETORDERLISTBYHOLD_V2, GETORDERLISTBYSTATUS_V2, DASHBOARDREPORT } from '@/store/actions.type'
import Vue from 'vue'
Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    // value = value.toString('yyyyMMddHHmmss').replace(/T/, ' ').replace(/\..+/, '').replace(/Z/, ' ')
    // let auxCopia = value.split(' ')
    // value = auxCopia[0]
    // let d = auxCopia[1]
    // value = value + ' ' + d
    // return value
    /*
    var b = value.split(/\D/)
    value = new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5], ((b[6] || '') + '000').slice(0, 3))
    return (
      new Date(value).toLocaleDateString() +
      ' ' +
      new Date(value).toLocaleTimeString()
    )
    */
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'home',
  components: {
    Header,
    addOrder,
    dataTable
  },
  data () {
    return {
      dataTableData: {
        count: 0,
        next: null,
        previous: null,
        results: []
      },
      exportURL: null,
      baseAPIUrl: API_URL,
      selected: [],
      loading: true,
      dashboardReport: null,
      rtsQueue: null,
      itemsPerPage: 10,
      page: 1,
      activeTab: 'Active Order',
      activeOrderStatus: ['Assign', 'Waiting Docs', 'In House', 'Examine', 'Rejected Docs',
        'Data Entry', 'Q / A', 'Approved To Sent', 'QA Feedback', 'Client Rejected', 'Bot Search'],
      currentStatusFilter: ['Assign', 'Waiting Docs', 'In House', 'Examine', 'Rejected Docs',
        'Data Entry', 'Q / A', 'Approved To Sent', 'QA Feedback', 'Client Rejected', 'Bot Search'],
      filters: [
        {
          name: 'Assign'
        },
        {
          name: 'Waiting Docs'
        },
        {
          name: 'Bot Search'
        },
        {
          name: 'In House'
        },
        {
          name: 'Examine'
        },
        {
          name: 'Rejected Docs'
        },
        {
          name: 'Data Entry'
        },
        {
          name: 'Q / A'
        },
        {
          name: 'Approved To Sent'
        },
        {
          name: 'QA Feedback'
        },
        {
          name: 'Sent'
        },
        {
          name: 'On Hold'
        },
        {
          name: 'Client Rejected'
        }
      ],
      headers: [
        {
          text: 'Universal RTS Number',
          align: 'left',
          sortable: false,
          value: 'universal_rts_number'
        },
        { text: 'Client', value: 'client.name', sortable: false },
        { text: 'Client Ref#', value: 'client_reference', sortable: false },
        { text: 'Address', value: 'address', sortable: false },
        { text: 'County', value: 'address.county.name', sortable: false },
        { text: 'State', value: 'address.state.name', sortable: false },
        { text: 'Borrower', value: 'first_borrower', sortable: false },
        { text: 'Order Date', value: 'created_on', sortable: false },
        { text: 'Due Date', value: 'due_on', sortable: false },
        { text: 'Vendor', value: 'vendor', sortable: false },
        { text: 'Status', value: 'status.name', sortable: false },
        { text: 'Product', value: 'product.name', sortable: false },
        { text: 'On Hold', value: 'on_hold', sortable: false }
      ],
      orderList: [],
      height: 180,
      statusCount: null,
      orderCountByCustomer: null
    }
  },
  mounted () {
    let homePageMenu = JwtService.getHomePageMenu()
    this.filters = homePageMenu
    // console.log(homePageMenu)
    // alert(1)
    // this.filters = [{ 'name': 'In House' }]
    this.loading = true
    this.loadOrder()
    this.$store.dispatch(DASHBOARDREPORT)
      .then(response => {
        this.dashboardReport = response
        this.rtsQueue = this.dashboardReport.rtsQueue
        this.statusCount = this.dashboardReport.orderCountByStage
        // var items = Object.keys(this.dashboardReport.orderCountByCustomer).map(function (key) {
        //   return [key, this.dashboardReport.orderCountByCustomer[key]]
        // })
        // items.sort(function (first, second) {
        //   return second[1] - first[1]
        // })
        // console.log(items)
        this.orderCountByCustomer = this.dashboardReport.orderCountByCustomer
        this.loading = false
      })
  },
  methods: {
    paginateOrder (conf) {
      console.log(conf)
      this.itemsPerPage = conf.itemsPerPage
      this.page = conf.page
      this.loadOrder()
    },
    openOrderPage (order) {
      this.$router.push(`/order/${order.id}/`)
    },
    changeTab (tab) {
      this.activeTab = tab
      this.page = 1
      if (tab === 'Active Order') {
        this.currentStatusFilter = this.activeOrderStatus
      } else {
        this.currentStatusFilter = [tab]
      }
      if (tab === 'On Hold') {
        this.loading = true
        let orderPayload = {
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          on_hold: true
        }
        this.$store.dispatch(GETORDERLISTBYHOLD_V2, orderPayload)
          .then(response => {
            this.orderList = response.results
            this.dataTableData = response
            this.exportURL = `${this.baseAPIUrl.BASE_API_URL}/download_orders/?on_hold=${orderPayload.on_hold}`
            this.loading = false
          })
      } else {
        this.loadOrder()
      }
    },
    loadOrder () {
      this.loading = true
      let orderPayload = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        status__name__in: this.currentStatusFilter
      }
      this.$store.dispatch(GETORDERLISTBYSTATUS_V2, orderPayload)
        .then(response => {
          this.orderList = response.results
          this.dataTableData = response
          this.exportURL = `${this.baseAPIUrl.BASE_API_URL}/download_orders/?status__name__in=${orderPayload.status__name__in}`
          console.log(this.exportURL)
          this.loading = false
        })
    }
  }
}
</script>

<style>
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto;
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td,
.v-data-table th {
  padding: 0 5px;
}
.v-application .elevation-1 {
  width: 100%;
}
.row {
  width: 100%;
  margin: auto;
}
.elevation-1 .v-chip{
  background: white !important;
}
.rtsFilter{
  font-size: 0.65rem !important;
  background: white !important;
  border-radius: 0px;
  border-right: solid 1px #f1f1f1;
}
</style>
